import { CACHE_KEY } from "../utility/Constant";
import {
  fetchTemplateWithCache,
  fetchWithCache,
  mutateAndRefresh,
} from "./cache.service";
import API from "./http-helper.service";

export const fetchRegions = () =>
  fetchWithCache(CACHE_KEY.REGIONS, () => API.get("builder/assetMgmt/region"));

export const fetchSites = (regionId) => {
  if (!regionId || regionId === "undefined" || regionId === "null") {
    return Promise.resolve([]);
  }
  return fetchWithCache(`${regionId}-${CACHE_KEY.SITES}`, () =>
    API.get("builder/assetMgmt/region/" + regionId + "/sites"),
  );
};

export const fetchAllSites = () =>
  fetchWithCache(CACHE_KEY.ALL_SITES, () => API.get("builder/assetMgmt/sites"));

export const fetchTurbinesBySite = (siteId) =>
  fetchWithCache(`${siteId}-${CACHE_KEY.TURBINES}`, () =>
    API.get("builder/assetMgmt/turbines?siteId=" + siteId),
  );

export const fetchLanguages = () =>
  fetchWithCache(CACHE_KEY.LANGUAGES, () => API.get("language"));

export const fetchCategories = () =>
  fetchWithCache(CACHE_KEY.CATEGORIES, () => API.get("category"));

export const fetchOptionalEquipments = () =>
  fetchWithCache(CACHE_KEY.OPTIONAL_EQUIPMENTS, () =>
    API.get("optionalEquipment"),
  );

export const createOptionalEquipment = (equipmentData) =>
  mutateAndRefresh(
    CACHE_KEY.OPTIONAL_EQUIPMENTS,
    () => API.post("optionalEquipment", equipmentData, { includeUserId: true }),
    fetchOptionalEquipments,
  );

export const deleteOptionalEquipment = (equipmentId) =>
  mutateAndRefresh(
    CACHE_KEY.OPTIONAL_EQUIPMENTS,
    () =>
      API.put(
        "optionalEquipment/delete-by-id",
        {
          optionalEquipmentId: equipmentId,
        },
        { includeUserId: true },
      ),
    () => fetchOptionalEquipments,
  );

export const getFormTemplateById = (formId) =>
  fetchTemplateWithCache(
    CACHE_KEY.FORM_TEMPLATES,
    () => API.get(`builder/forms/${formId}`, { includeUserId: true }),
    formId,
  );
